var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"banner"}},[_c('div',[_c('div',{staticClass:"bg-header-home"},[_c('div',{staticClass:"col-lg-12 tx-home-header"})])])])}]

export { render, staticRenderFns }